import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository } from '@softline/core';
import { SOFTLINE_API_EVENT_SERVICE_EVENTS } from '../events.api';
import { EventServiceEvent, EventServiceEventsQuery } from '../types/event';

@Injectable()
export class EventServiceRepository extends ReadonlyHttpApiCollectionRepository<
  EventServiceEvent[],
  EventServiceEventsQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_EVENT_SERVICE_EVENTS);
  }

  loadEventsFromCurrentUser(params: {
    from: string;
    to: string;
  }): Promise<EventServiceEvent[]> {
    return this.dataAccess.get({
      path: `${this.path}/me`,
      queryParams: params,
    });
  }

  protected override getLoadQueryParams(params: EventServiceEventsQuery) {
    return { from: params.from, to: params.to, user: params.user };
  }
}
